<template>
    <div class="page recipesList" @scroll="pageScroll" ref="page">
        <div class="pageContainer">
            <div class="container">
                <h2 class="d-flex justify-content-between align-items-center">
                    <img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)" alt="back">
                    <span v-if="getLng() == 'en'">{{ Object.keys(searchData.pageFilter).length ? searchData.pageFilter.name : "Recipes"}}</span>
                    <span v-else>{{ Object.keys(searchData.pageFilter).length ? searchData.pageFilter.spanish_name : "Recetas"}}</span>
                    
                    <span style="width: 35px"></span>
                </h2>
                <div v-if="searchResults.total" class="position-relative">
                    <div class="text-right smallText">
                        {{ $t('filters.Showing' )}} {{ currentShowed }} of {{searchResults.total}}
                        {{$t('filters.Recipes')}}
                    </div>
                    <transition-group
                        tag="div"
                        class="list"
                        name="custom-zoom"
                    >
                        <RecipeListItem
                            v-for="(recipe, index) in searchList"
                            v-if="searchResults.total && startAnimation && ($route.query.page_filter === undefined)"
                            :key="recipe.id"
                            :recipe="recipe"
                        ></RecipeListItem>
                    
                    </transition-group>
                    
                    <div
                        style="position: absolute; bottom: 1000px;"
                        v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
                        v-if="(searchResults.current_page < searchResults.last_page) && ($route.query.page_filter === undefined)"
                    ></div>
                    
                    <div class="text-center" v-if="searchResults.current_page < searchResults.last_page">
                        <Loader></Loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import RecipeListItem from "./RecipeListItem";
    import Loader from "./Loader";

    import pageMixin from "../mixins/page";

    export default {
        name: "RecipesList",
        mixins: [pageMixin],
        components: {RecipeListItem, Loader},
        data() {
            return {
                intersectionOptions: {
                    root: null,
                    rootMargin: '0px 0px 0px 0px',
                }
            }
        },
        methods: {
            onWaypoint({going, direction}) {
                // going: in, out
                // direction: top, right, bottom, left
                if (going === this.$waypointMap.GOING_IN) {
                    this.searchData.page++;
                    this.$store.dispatch("search/getRecipes", true);
                }

                /*if (direction === this.$waypointMap.DIRECTION_TOP) {
                    console.log('waypoint going top!')
                }*/
            },
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            }
        },
        computed: {
            ...mapState("search", ["searchResults", "searchData", "searchList", "selectedFilterList"]),
            ...mapState("shared", ["preloaded"]),
            currentShowed() {
                let val = (this.searchResults.per_page * this.searchResults.current_page);
                if (this.searchResults.total < val) val = this.searchResults.total;
                return val;
            }
        },
        mounted() {
            if (Object.keys(this.searchData.pageFilter).length) {
                this.changePageTitle(this.searchData.pageFilter.name + " | ABM Cocktail Pro");
            } else {
                this.changePageTitle("Professionally Curated Cocktail Recipes | ABM Cocktail Pro");
            }
        },
        created() {
            if (this.$route.query.filter) {
                this.$store.commit("search/unsetSelectedFilterList");
                this.searchData.filters.push(this.$route.query.filter);
                this.searchData.pageFilter = this.preloaded.filters.find(el => el.id == this.$route.query.filter);
                this.selectedFilterList[this.searchData.pageFilter.id] = this.searchData.pageFilter;
                this.$store.dispatch("search/getRecipes", true);
            } else {

                if (Object.keys(this.searchData.pageFilter).length && !this.$route.query.filter) {
                    this.searchData.pageFilter = {};
                    this.$store.commit("search/unsetSelectedFilterList");
                    this.$store.dispatch("search/getRecipes", true);
                }

                if (!Object.keys(this.searchList).length || Object.keys(this.searchList).length > 24) {
                    this.$store.commit("search/unsetSearchList");
                    this.$store.dispatch("search/getRecipes", true);
                }
            }
        }
    }
</script>


<style scoped lang="scss">
    .custom-zoom-enter-active, .custom-zoom-leave-active { // I don't know why but animate.css flickering screen on zoom
        transition: transform 1s ease-out;
    }
    
    .custom-zoom-enter, .custom-zoom-leave-to {
        transform: scale(0.1);
    }
</style>
